import { Button, Classes, ControlGroup, Dialog, Tag } from "@blueprintjs/core";
import { Users } from "@just-in-types";
import { isAfter } from "date-fns";
import { Dictionary, groupBy } from "lodash";
import * as React from "react";
import ActiveCheckIn, { ActiveCheckInProps } from ".";
import { isTimestamp } from "../helpers";
import CouponsList from "./CouponsList";

interface Props {
  activeBusinessId: ActiveCheckInProps["businessId"];
  activeSiteId: ActiveCheckInProps["siteId"];
  coupons: Users.Coupon[];
  displayCoupon?:boolean;
  loading: boolean;
  loyaltyCycleText: string;
  redeemCoupon: ActiveCheckIn["redeemCoupon"];
  redeeming: boolean;
}

interface State {
  isOpen: boolean;
}

export enum CouponGroups {
  ACTIVE = "Active",
  EXPIRED = "Expired",
  REDEEMED = "Redeemed",
}

const groupCoupons = (coupons: Users.Coupon[]) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const groups = groupBy(coupons, ({ expires_date, redemption_flag }) => {
    if (redemption_flag) {
      return CouponGroups.REDEEMED;
    }

    if (expires_date && isTimestamp(expires_date)) {
      // console.log("checking expiry...");
      // console.log(yesterday);
      // console.log(expires_date.toDate());
      if (isAfter(yesterday, expires_date.toDate())) {
        return CouponGroups.EXPIRED;
      }
    }

    return CouponGroups.ACTIVE;
  });

  // Gotta sort the keys... for usability.
  return {
    [CouponGroups.ACTIVE]: groups[CouponGroups.ACTIVE] || [],
    [CouponGroups.EXPIRED]: groups[CouponGroups.EXPIRED] || [],
    [CouponGroups.REDEEMED]: groups[CouponGroups.REDEEMED] || [],
  };
};

const buildLists = (
  activeBusinessId: Props["activeBusinessId"],
  activeSiteId: Props["activeSiteId"],
  couponGroups: Dictionary<Users.Coupon[]>,
  redeeming: boolean,
  redeemCoupon: ActiveCheckIn["redeemCoupon"]
) => {
  const tables: JSX.Element[] = [];

  for (const key in couponGroups) {
    if (key) {
      const coupons = couponGroups[key];

      if (coupons.length > 0) {
        tables.push(
          <CouponsList
            {...{
              activeBusinessId,
              activeSiteId,
              coupons,
              key,
              redeemCoupon,
              redeeming,
              title: key,
            }}
          />
        );
      }
    }
  }

  return tables;
};

class Coupons extends React.PureComponent<Props, State> {
  public state: State = { isOpen: false };

  public render() {
    const { activeBusinessId, activeSiteId, coupons, loading, loyaltyCycleText, redeeming, redeemCoupon } = this.props;
    const { isOpen } = this.state;

    const groups = groupCoupons(coupons);

    const couponsCount = coupons.length;
    const activeCount = groups[CouponGroups.ACTIVE] ? groups[CouponGroups.ACTIVE].length : 0;
    let buttonText;
    if (couponsCount > 0) {
      if (activeCount === 0) {
        buttonText = `${couponsCount} Past Coupons`;
      } else {
        buttonText = activeCount === 1 ? `${activeCount} Active Coupon` : `${activeCount} Active Coupons`;
      }
    } else {
      buttonText = "No Coupons!";
    }
    const lists = buildLists(activeBusinessId, activeSiteId, groups, redeeming, redeemCoupon);

    return (
      <>
        <span id="coupon-style" style={{ display:this.props.displayCoupon?'block':'none' }}>
          <ControlGroup
            fill={true}
            style={{
              display: "grid",
              gridTemplateColumns: "30% 1fr",
              marginBottom: "0.5rem",
            }}
          >
            <Tag large={true}>Coupons</Tag>

            <Button
              disabled={couponsCount === 0}
              intent={activeCount > 0 ? "success" : "primary"}
              loading={loading}
              onClick={this.openDialog}
              text={buttonText}
            />
          </ControlGroup>
        </span>
        <span style={{ display:this.props.displayCoupon?'none':'block' }}>
        <ControlGroup
          fill={true}
          style={{
            display: "grid",
            gridTemplateColumns: "30% 1fr",
            marginBottom: "0.5rem",
          }}
        >
          <Tag large={true}>Next Coupon: </Tag>
          <Tag large={true} minimal={true}>
            {loyaltyCycleText}
          </Tag>
        </ControlGroup>
        </span>
        <Dialog isOpen={isOpen} onClose={this.closeDialog} title="Coupons" style={{ maxHeight: "95vh" }}>
          <div className={Classes.DIALOG_BODY}>{lists}</div>
        </Dialog>
      </>
    );
  }

  private openDialog = () => this.setState({ isOpen: true });

  private closeDialog = () => this.setState({ isOpen: false });
}

export default Coupons;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/Coupons.tsx